import marked from 'marked';

const renderMarkdown = content => marked(content || '');

export default renderMarkdown;
